/* eslint-disable react-hooks/exhaustive-deps */
import { loadingCompleted } from '../../store/loading/actions';
import styles from './LoadingBox.module.scss';
import cn from 'classnames';
import { useEffect, useState } from 'preact/hooks';
import { useDispatch, useSelector } from 'react-redux';

const CLOSE_DELAY_MS = 300;

const Loading = () => {
  const { visible, startTime, howManyStages, currentStage } = useSelector((s) => s.loading);
  const dispatch = useDispatch();
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const goTo = currentStage + 1;
    let value;

    if (goTo < howManyStages) {
      value = Math.floor((goTo / (howManyStages || 1)) * 99);
    } else {
      value = 99;
    }

    setPercentage(value);
  }, [startTime, howManyStages, currentStage]);

  useEffect(() => {
    if (currentStage === howManyStages) {
      setTimeout(() => {
        dispatch(loadingCompleted());
      }, CLOSE_DELAY_MS);
    }
  }, [howManyStages, currentStage]);

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.loading}>
      <div className={styles.content}>
        <div className={styles.progress}>
          <div
            className={cn(styles.indicator, currentStage >= howManyStages && styles.completed)}
            style={{ width: `${currentStage >= howManyStages ? 100 : percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

const LoadingWrapper = () => {
  const { startTime } = useSelector((s) => s.loading);

  return <Loading key={startTime} />;
};

export default LoadingWrapper;
